<div class="sticky-footer">
    <div class="menu-item">
        <button mat-button [routerLink]="'/'">
            <mat-icon>home</mat-icon>
        </button>
        <mat-label>Accueil</mat-label>
    </div>  

    <div class="menu-item">
        <button mat-button [routerLink]="'buy/search'">
            <mat-icon>search</mat-icon> 
        </button>
        <mat-label>Acheter</mat-label> 
    </div>

    <div class="menu-item">
        <button mat-button [routerLink]="'rent/search'">
            <mat-icon>search</mat-icon> 
        </button>
        <mat-label>Louer</mat-label> 
    </div>
<!-- 
    <div class="menu-item">
        <button mat-button [routerLink]="'provider'"> 
            <mat-icon>storefront</mat-icon>  
        </button>
        <mat-label>Provider</mat-label> 
    </div>

    <div class="menu-item">
        <button mat-button [routerLink]="'customer'" aria-label="Example icon-button with heart icon">
            <mat-icon [matBadge]="(totalFavorites$ | async)" matBadgeColor="warn">shopping_bag</mat-icon>
        </button>
        <mat-label>Acheteur</mat-label> 
    </div> -->

    <div class="menu-item">
        <button mat-button [routerLink]="'account/infos'"  aria-label="Example icon-button with menu icon">
            <mat-icon [matBadge]="(isLoggedIn() === true ? getLoggedInChar() : '')" >account_circle</mat-icon> 
        </button>
        <mat-label>Compte</mat-label> 
    </div>
    
</div> 